export default __webpack_public_path__ + "95deb0d3cd2403e924069e4d31e043e4.geojson";